import React, { useEffect, useState } from 'react';

import { createContext, useContext, useMemo } from "react";

import { onAuthStateChanged } from "firebase/auth";
import { auth } from '../firebase';

const AuthContext = createContext({user: null, setUser: (user) => {}});

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        const unsubscribe = onAuthStateChanged(auth, (user) => {
          setLoading(false);
          if (user) {
            setUser(user);
          } else {
            setUser(null);
          }
        });

        return () => unsubscribe();
    }, []);

  const value = useMemo(
    () => ({
      user,
      setUser,
      loading,
    }),
    [user, loading]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;